export const SLUG_MAP_PUZZLE = 'custom-puzzle';

export const steps: { heading?: string; progressHeading: string }[] = [
  {
    heading: 'Choose the puzzle size',
    progressHeading: 'Choose the puzzle size',
  },
  {
    heading: 'Design your map',
    progressHeading: 'Design your map',
  },
];

export const THEMES = [
  { id: 'noir', name: 'Noir', description: 'Classic black and white elegance' },
  { id: 'terracotta', name: 'Terracotta', description: 'Mediterranean warmth' },
  { id: 'midnight_blue', name: 'Midnight Blue', description: 'Deep ocean vibes' },
  { id: 'autumn', name: 'Autumn', description: 'Warm fall colors' },
  { id: 'blueprint', name: 'Blueprint', description: 'Technical drawing style' },
  { id: 'contrast_zones', name: 'Contrast Zones', description: 'Bold contrasts' },
  { id: 'copper_patina', name: 'Copper Patina', description: 'Aged copper tones' },
  { id: 'emerald', name: 'Emerald', description: 'Rich green hues' },
  { id: 'forest', name: 'Forest', description: 'Natural woodland colors' },
  { id: 'gradient_roads', name: 'Gradient Roads', description: 'Colorful road gradients' },
  { id: 'japanese_ink', name: 'Japanese Ink', description: 'Sumi-e inspired' },
  { id: 'neon_cyberpunk', name: 'Neon Cyberpunk', description: 'Futuristic neon glow' },
  { id: 'ocean', name: 'Ocean', description: 'Coastal blues and teals' },
  { id: 'pastel_dream', name: 'Pastel Dream', description: 'Soft pastel palette' },
  { id: 'sunset', name: 'Sunset', description: 'Golden hour warmth' },
  { id: 'warm_beige', name: 'Warm Beige', description: 'Neutral earth tones' },
] as const;

export type ThemeId = (typeof THEMES)[number]['id'];
